module.exports = __webpack_public_path__ + "fonts/montserrat-semibold.6fb1b562.woff2";